import { all } from 'redux-saga/effects';
import fetchIncident from './fetchIncident';

import fetchIncidents from './fetchIncidents';
import { updateIncidentSaga } from './updateIncident';

export default function* () {
    yield all([fetchIncidents(), fetchIncident(), updateIncidentSaga()]);
}
